/** First-level module ids (order for tab strip left-to-right) */
export const MODULE_TAB_ORDER = [
  'reporting',
  'approval',
  'calendar',
  'search',
  'statistics',
  'admin',
];

const REPORTING_PATH_PREFIXES = ['/report'];

export function pathToModuleId(pathname, isMTR) {
  if (!pathname) return null;
  if (isMTR) return null;
  if (
    pathname.startsWith('/profile') ||
    pathname.startsWith('/demo') ||
    pathname === '/add-patient'
  ) {
    return null;
  }
  if (REPORTING_PATH_PREFIXES.some((p) => pathname.startsWith(p))) {
    return 'reporting';
  }
  if (pathname === '/' || pathname === '/my-tasks' || pathname === '/team-tasks') {
    return 'reporting';
  }
  if (pathname.startsWith('/approval')) return 'approval';
  if (pathname.startsWith('/calendar')) return 'calendar';
  if (pathname.startsWith('/search')) return 'search';
  if (pathname.startsWith('/statistics')) return 'statistics';
  if (pathname.startsWith('/admin')) return 'admin';
  return null;
}

export function moduleDefaultRoute(moduleId) {
  switch (moduleId) {
    case 'reporting':
      return '/';
    case 'approval':
      return '/approval';
    case 'calendar':
      return '/calendar';
    case 'search':
      return '/search';
    case 'statistics':
      return '/statistics';
    case 'admin':
      return '/admin';
    default:
      return '/';
  }
}

export function canAccessModule(moduleId, gates) {
  const {
    isMTR,
    approvalWorkflowEnabled,
    canApprove,
    canViewCalendar,
    canViewStats,
    isAdmin,
    canManageReporting,
  } = gates;
  if (isMTR) return false;
  switch (moduleId) {
    case 'reporting':
      return true;
    case 'approval':
      return approvalWorkflowEnabled && canApprove === true;
    case 'calendar':
      return canViewCalendar === true;
    case 'search':
      return true;
    case 'statistics':
      return canViewStats === true;
    case 'admin':
      return isAdmin === true || canManageReporting === true;
    default:
      return false;
  }
}

export function availableModuleIds(gates) {
  return MODULE_TAB_ORDER.filter((id) => canAccessModule(id, gates));
}

export function normalizeOpenModuleIds(openIds, gates) {
  const allowed = new Set(availableModuleIds(gates));
  const filtered = (openIds || []).filter((id) => allowed.has(id));
  if (!filtered.length && allowed.has('reporting')) {
    return ['reporting'];
  }
  if (!filtered.length) {
    return Array.from(allowed).slice(0, 1);
  }
  return filtered;
}
